import { useSelector } from 'react-redux';
import './App.css';
import { useEffect, useState } from 'react';
import { RootState } from './redux/store/store';
import { showInfoToast } from './utils/ToastMessages/ToastMessages';
import OfflineMessage from './components/OfflineMessage/OfflineMessage';
import LoginScreen from './screens/LoginScreen/LoginScreen';
import HomeScreen from './screens/HomeScreen/HomeScreen';

function App() {
  const token = useSelector((state: RootState) => state.auth.token);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      window.location.reload();
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const handleRetry = () => {
    // Simulate checking connection status
    if (navigator.onLine) {
      setIsOnline(true);
    } else {
      showInfoToast("Still offline. Please check your connection.");
    }
  };

  return isOnline ? (
    token && token !== "undefined" ? (
      <HomeScreen />
    ) : (
      // <RegisterScreen />
      <LoginScreen />
    )
  ) : (
    <OfflineMessage
      props={{
        handleRetry: handleRetry,
        isOnline: isOnline,
      }}
    />
  );
}

export default App;
